/**
 * 场地管理。场地标签现在住在**设备上**(~/0xman/config/site,由 supervisor 注入
 * OXMAN_SITE 写进现场部署日志),hub 这边没有场地表。
 */
import { NoDataSource } from '@/components/feature/DataSource';

export default function SiteManager() {
  return (
    <>
      <NoDataSource
        title="hub 还没有场地表"
        reason="场地标签目前是设备本地的一个文件(~/0xman/config/site),随现场部署日志一起记录。要在云端管场地,得先有场地表,以及把标签下发到设备的通道 —— 两样都还没有。"
        phase="P4 · 配置下发 + 场地表"
      />
      <p className="mt-3 text-[11px] text-foreground-400 leading-relaxed">
        在那之前换场地:改设备上的 <span className="font-mono">~/0xman/config/site</span> 并重启 server,
        或运行时调 <span className="font-mono">POST /api/v1/mission/site</span>。空着的话现场日志里的场地数永远是 0。
      </p>
    </>
  );
}
